import { createFileRoute, Outlet } from '@tanstack/react-router';
import cx from 'clsx';
import { useEffect } from 'react';

import { fonts } from 'shared/fonts';

export const Route = createFileRoute('/lobby')({
  component: LobbyLayout
});

function LobbyLayout() {
  useEffect(() => {
    document.documentElement.className = cx(fonts.map(font => font.variable).filter(Boolean));
  }, []);

  return <Outlet />;
}
